import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class AccountService {
    constructor(private http: HttpClient) {
    }

    public get(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get<any>(environment.apiUrl + 'account/get').subscribe(data => {
                resolve(data);
            }, error => {
                //console.log(error);
                reject();
            });
        });
    }
}
